import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TextField,
  Typography,
  Button,
  Tabs,
  Tab,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { orderSectionData } from "../../../redux/slices/orgAdmin/promotionsSlice";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useMediaQuery, useTheme } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import Pagination from "@mui/material/Pagination";
import DeleteIcon from "@mui/icons-material/Delete";
import { fetchLanguages } from "../../../redux/slices/superAdmin/languagesSlice";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CollectionsIcon from "@mui/icons-material/Collections";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { styled } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
import { buildMedia } from "../../Utils/AuthService";
import Attachments from "./Utils/Attachments";
import GalleryUpload from "./Utils/GalleryUpload";
import { rowsPerPage } from "../../../Constants";

import {
  StyledButton,
  StyledContainer,
  StyledTableCell,
} from "../../CSS/Styles";
import {
  fetchEvents,
  saveEvent,
  getEvent,
} from "../../../redux/slices/orgAdmin/eventSlice";
import { deleteSectionData } from "../../../redux/slices/orgAdmin/promotionsSlice";
import {
  fetchTeams,
  getTeam,
  saveTeam,
} from "../../../redux/slices/orgAdmin/teamSlice";

export default function Team() {
  const dispatch = useDispatch();
  const { teamList, loading } = useSelector((state) => state.team);
  const { languagesList } = useSelector((state) => state.languages);
  const { companyId } = useSelector((state) => state.app);
  const { config } = useSelector((state) => state.app);
  const [deleteTitle, setDeleteTitle] = useState("");
  const [media, setMedia] = useState(null);
  const [updatedEvent, setUpdatedEvent] = useState({
    en: { title: "", brief: "", location: "", description: "", yt_url: "" },
    fr: { title: "", brief: "", location: "", description: "", yt_url: "" },
    ar: { title: "", brief: "", location: "", description: "", yt_url: "" },

    attachments: {
      mainImage: [],
      report: [],
    },
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [galleryDialogOpen, setGalleryDialogOpen] = useState(false);
  const [galleryId, setGalleryId] = useState(null);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [promotionIdToDelete, setPromotionIdToDelete] = useState(null);
  const [localNews, setLocalNews] = useState([]);

  const [page, setPage] = useState(1);
  const totalRecords = teamList?.pagination?.totalRecords || teamList.length;
  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const files = {};

  useEffect(() => {
    dispatch(fetchTeams({ companyId, page, limit: rowsPerPage }));
    dispatch(fetchLanguages());
  }, [dispatch, companyId, page]);

  const sectionId = 8;

  const [isAddingTeam, setIsAddingTeam] = useState(false);
  const defaultLanguage =
    languagesList.find(
      (lang) => lang.is_default === 1 || lang.is_default === "1"
    )?.code || "en";
  const [currentLanguage, setCurrentLanguage] = useState(defaultLanguage);
  const availableLanguages = languagesList?.map((lang) => lang.code);
  const [newTeam, setNewTeam] = useState({
    en: {
      firstName: "",
      lastName: "",
      email: "",
      description: "",
      brief: "",
      profession: "",
      yt_url: "",
      facebook_url: "",
      linkedin_url: "",
      custom_checkbox: false,
    },
    fr: {
      firstName: "",
      lastName: "",
      email: "",
      description: "",
      brief: "",
      profession: "",
      yt_url: "",
      facebook_url: "",
      linkedin_url: "",
      custom_checkbox: false,
    },
    ar: {
      firstName: "",
      lastName: "",
      email: "",
      description: "",
      brief: "",
      profession: "",
      yt_url: "",
      facebook_url: "",
      linkedin_url: "",
      custom_checkbox: false,
    },

    attachments: {
      mainImage: [],
      report: [],
    },
  });

  const [rowToEdit, setRowToEdit] = useState(null);

  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);

  const handleInputChange = (language, field, value) => {
    setNewTeam((prev) => ({
      ...prev,
      [language]: {
        ...prev[language],
        [field]: value,
      },
    }));
  };

  useEffect(() => {
    if (teamList?.data) {
      setLocalNews(teamList.data);
    }
  }, [teamList]);

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedItems = Array.from(localNews);
    const [removed] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, removed);

    setLocalNews(reorderedItems);

    // Prepare the payload for dispatch with the reordered data
    const reorderedData = reorderedItems.map((item, index) => ({
      id: item.id,
      sortIndex: index + 1, // Assuming that you want to track the index for sorting
    }));

    // Dispatch the action to persist changes in the order
    dispatch(orderSectionData(reorderedData))
      .unwrap()
      .then(() => {
        dispatch(fetchEvents({ companyId, page, limit: rowsPerPage }));
      })
      .catch((error) => {
        console.error("Error updating order:", error);
      });
  };

  const handleDeleteMainImage = (isDeleted) => {
    setNewTeam((prev) => ({
      ...prev,
      deleteMainImage: isDeleted, // ✅ Dynamically update promotionData
    }));
  };

  const handleDeleteAttachment = (language, attachmentId) => {
    setNewTeam((prev) => {
      const updatedDeletedAttachments = new Set(prev.deletedAttachments || []);

      // Add language to the Set if an attachment was deleted
      updatedDeletedAttachments.add(language);

      return {
        ...prev,
        deletedAttachments: Array.from(updatedDeletedAttachments), // Convert Set back to Array
      };
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setNewTeam((prev) => ({ ...prev, attachment: file }));
    }
  };

  const handleEditTeam = async (id) => {
    console.log(newTeam[currentLanguage]?.firstName);
    try {
      setRowToEdit(id);
      const teamData = await dispatch(getTeam({ id })).then(
        (res) => res.payload
      );

      if (!teamData || !teamData.data) return;

      const teamId = teamData.data?.id;
      const mainImage = teamData.data?.mainImage || "";

      // Build attachments array
      const attachments = Object.keys(teamData.data)
        .filter(
          (lang) =>
            ["en", "fr", "ar"].includes(lang) && teamData.data[lang]?.attachment
        )
        .map((lang) => ({
          languageId: lang,
          fileName: teamData.data[lang].attachment,
        }));

      const mediaData = buildMedia(companyId, teamId, mainImage, attachments);
      setMedia(mediaData);

      // ✅ FIXED: Properly structure the team data for each language
      const prefilledTeam = {
        en: {
          firstName:
            teamData.data?.en?.firstName || teamData.data?.firstName || "",
          lastName:
            teamData.data?.en?.lastName || teamData.data?.lastName || "",
          email: teamData.data?.en?.email || teamData.data?.email || "",
          description:
            teamData.data?.en?.description || teamData.data?.description || "",
          brief: teamData.data?.en?.brief || teamData.data?.brief || "",
          profession:
            teamData.data?.en?.profession || teamData.data?.profession || "",
          yt_url: teamData.data?.en?.yt_url || teamData.data?.yt_url || "",
          facebook_url:
            teamData.data?.en?.facebook_url ||
            teamData.data?.facebook_url ||
            "",
          linkedin_url:
            teamData.data?.en?.linkedin_url ||
            teamData.data?.linkedin_url ||
            "",
          custom_checkbox: Boolean(
            teamData.data?.en?.custom_checkbox ||
              teamData.data?.custom_checkbox ||
              false
          ),
        },
        fr: {
          firstName:
            teamData.data?.fr?.firstName || teamData.data?.firstName || "",
          lastName:
            teamData.data?.fr?.lastName || teamData.data?.lastName || "",
          email: teamData.data?.fr?.email || teamData.data?.email || "",
          description:
            teamData.data?.fr?.description || teamData.data?.description || "",
          brief: teamData.data?.fr?.brief || teamData.data?.brief || "",
          profession:
            teamData.data?.fr?.profession || teamData.data?.profession || "",
          yt_url: teamData.data?.fr?.yt_url || teamData.data?.yt_url || "",
          facebook_url:
            teamData.data?.fr?.facebook_url ||
            teamData.data?.facebook_url ||
            "",
          linkedin_url:
            teamData.data?.fr?.linkedin_url ||
            teamData.data?.linkedin_url ||
            "",
          custom_checkbox: Boolean(
            teamData.data?.fr?.custom_checkbox ||
              teamData.data?.custom_checkbox ||
              false
          ),
        },
        ar: {
          firstName:
            teamData.data?.ar?.firstName || teamData.data?.firstName || "",
          lastName:
            teamData.data?.ar?.lastName || teamData.data?.lastName || "",
          email: teamData.data?.ar?.email || teamData.data?.email || "",
          description:
            teamData.data?.ar?.description || teamData.data?.description || "",
          brief: teamData.data?.ar?.brief || teamData.data?.brief || "",
          profession:
            teamData.data?.ar?.profession || teamData.data?.profession || "",
          yt_url: teamData.data?.ar?.yt_url || teamData.data?.yt_url || "",
          facebook_url:
            teamData.data?.ar?.facebook_url ||
            teamData.data?.facebook_url ||
            "",
          linkedin_url:
            teamData.data?.ar?.linkedin_url ||
            teamData.data?.linkedin_url ||
            "",
          custom_checkbox: Boolean(
            teamData.data?.ar?.custom_checkbox ||
              teamData.data?.custom_checkbox ||
              false
          ),
        },
        attachments: mediaData,
        deleteMainImage: false,
        deletedAttachments: [],
      };

      // ✅ IMPORTANT: Set the newTeam state and force re-render
      setNewTeam(prefilledTeam);

      // ✅ Add a small delay to ensure state is updated before showing the form
      setTimeout(() => {
        setIsAddingTeam(true);
      }, 100);

      console.log("Prefilled team data:", prefilledTeam); // Debug log
    } catch (error) {
      console.error("Error fetching team data:", error);
    }
  };

  const handleAddTeam = () => {
    setRowToEdit(null);
    setMedia(null);
    setNewTeam({
      en: {
        firstName: "",
        lastName: "",
        email: "",
        description: "",
        brief: "",
        profession: "",
        yt_url: "",
        facebook_url: "",
        linkedin_url: "",
        custom_checkbox: false,
      },
      fr: {
        firstName: "",
        lastName: "",
        email: "",
        description: "",
        brief: "",
        profession: "",
        yt_url: "",
        facebook_url: "",
        linkedin_url: "",
        custom_checkbox: false,
      },
      ar: {
        firstName: "",
        lastName: "",
        email: "",
        description: "",
        brief: "",
        profession: "",
        yt_url: "",
        facebook_url: "",
        linkedin_url: "",
        custom_checkbox: false,
      },
      attachments: {},
    });
    setCurrentLanguage(currentLanguage);
    setIsAddingTeam(true);
  };

  const handleSaveLanguage = () => {
    if (currentLanguage === "ar") {
      handleFinalizeTeam();
    } else {
      setConfirmationDialogOpen(true);
    }
  };

  const handleGlobalChange = (field, value) => {
    setNewTeam((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleProceedToNextLanguage = () => {
    setConfirmationDialogOpen(false);

    if (currentLanguage === "en") {
      setCurrentLanguage("fr");
    } else if (currentLanguage === "fr") {
      setCurrentLanguage("ar");
    }
  };

  const handleAttachmentsChange = (newAttachments) => {
    setNewTeam((prevNews) => ({
      ...prevNews,
      attachments: {
        ...prevNews.attachments,
        [`attachment_${currentLanguage}`]: newAttachments.report
          ? newAttachments.report
          : prevNews.attachments[`attachment_${currentLanguage}`],
        mainImage: newAttachments.hasOwnProperty("mainImage")
          ? newAttachments.mainImage
          : prevNews.attachments.mainImage,
      },
    }));
  };

  const handleFinalizeTeam = () => {
    const payload = rowToEdit ? { id: rowToEdit } : {};
    let hasValidLanguageData = false;

    Object.entries(newTeam).forEach(([lang, data]) => {
      if (["en", "fr", "ar"].includes(lang)) {
        const hasData =
          data.firstName?.trim() ||
          data.lastName?.trim() ||
          data.email?.trim() ||
          data.description?.trim() ||
          data.brief?.trim() ||
          data.profession?.trim() ||
          data.yt_url?.trim() ||
          data.facebook_url?.trim() ||
          data.linkedin_url?.trim();

        if (hasData) {
          hasValidLanguageData = true;
          payload[lang] = {
            firstName: data.firstName?.trim() || "",
            lastName: data.lastName?.trim() || "",
            email: data.email?.trim() || "",
            description: data.description?.trim() || "",
            brief: data.brief?.trim() || "",
            profession: data.profession?.trim() || "",
            yt_url: data.yt_url?.trim() || "",
            facebook_url: data.facebook_url?.trim() || "",
            linkedin_url: data.linkedin_url?.trim() || "",
            custom_checkbox: data.custom_checkbox ? 1 : 0,
          };
        }
      }
    });

    if (!hasValidLanguageData) {
      alert("Please fill at least one language field before finalizing.");
      return;
    }

    if (newTeam.attachments?.mainImage?.length) {
      files["mainImage"] = newTeam.attachments.mainImage[0].file;
    }

    ["en", "fr", "ar"].forEach((lang) => {
      if (newTeam.attachments?.[`attachment_${lang}`]?.length) {
        files[`attachment_${lang}`] =
          newTeam.attachments[`attachment_${lang}`][0].file;
      }
    });

    if (rowToEdit && newTeam.deleteMainImage) {
      payload.deleteMainImage = true;
    }

    if (rowToEdit && newTeam.deletedAttachments?.length > 0) {
      payload.deletedAttachments = newTeam.deletedAttachments;
    }

    dispatch(saveTeam({ payload, sectionId, files }))
      .unwrap()
      .then(() => {
        dispatch(fetchTeams({ companyId, page, limit: rowsPerPage }));
        setNewTeam({
          en: {
            firstName: "",
            lastName: "",
            email: "",
            description: "",
            brief: "",
            profession: "",
            yt_url: "",
            facebook_url: "",
            linkedin_url: "",
            custom_checkbox: false,
          },
          fr: {
            firstName: "",
            lastName: "",
            email: "",
            description: "",
            brief: "",
            profession: "",
            yt_url: "",
            facebook_url: "",
            linkedin_url: "",
            custom_checkbox: false,
          },
          ar: {
            firstName: "",
            lastName: "",
            email: "",
            description: "",
            brief: "",
            profession: "",
            yt_url: "",
            facebook_url: "",
            linkedin_url: "",
            custom_checkbox: false,
          },
          attachments: {},
        });
        setConfirmationDialogOpen(false);
        setIsAddingTeam(false);
      })
      .catch((error) => {
        console.error("Error saving team:", error);
      });
  };

  const handleExitAndSave = () => {
    handleFinalizeTeam(); // Save the data

    setConfirmationDialogOpen(false); // Close the dialog
  };

  const handleDeleteClick = (id, title) => {
    setPromotionIdToDelete(id);
    setDeleteDialogOpen(true);
    setDeleteTitle(title);
  };

  const handleShowGallery = (id, title) => {
    setGalleryId(id);
    setGalleryDialogOpen(true);
    setDeleteTitle(title);
  };

  const confirmDelete = () => {
    dispatch(deleteSectionData({ id: promotionIdToDelete, sectionId }))
      .then(() => {
        setDeleteDialogOpen(false);
        setPromotionIdToDelete(null);

        // Fetch updated promotions list after successful deletion
        dispatch(fetchEvents({ companyId, page, limit: rowsPerPage }));
      })
      .catch((error) => {
        console.error("Error deleting promotion:", error);
      });
  };

  return (
    <StyledContainer>
      <Paper elevation={3} sx={{ padding: 3 }}>
        {!isAddingTeam && (
          <>
            <Typography variant="h5" sx={{ mb: 2 }}>
              {config?.isDeputyLabel ? "Deputies" : "Team"}
            </Typography>
            <StyledButton
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={handleAddTeam}
              sx={{ marginBottom: 2 }}
              disabled={loading}
            >
              Add
            </StyledButton>

            <TableContainer component={Paper}>
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="newsTable">
                  {(provided) => (
                    <Table ref={provided.innerRef} {...provided.droppableProps}>
                      <TableHead>
                        <TableRow>
                          <StyledTableCell width="5%"></StyledTableCell>
                          <StyledTableCell
                            width={languagesList.length >= 2 ? "65%" : "80%"}
                          >
                            Name
                          </StyledTableCell>

                          <StyledTableCell width="15%">Actions</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(teamList?.data || []).map((item, index) => (
                          <Draggable
                            key={item.id}
                            draggableId={item.id.toString()}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <TableRow
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                style={{
                                  ...provided.draggableProps.style,
                                  backgroundColor: snapshot.isDragging
                                    ? "#f5f5f5"
                                    : "inherit",
                                }}
                              >
                                {/* Drag Handle */}
                                <TableCell {...provided.dragHandleProps}>
                                  <DragIndicatorIcon />
                                </TableCell>

                                {/* Title - Updated to show firstName + lastName */}
                                <TableCell>
                                  {`${item.firstName || ""} ${item.lastName || ""}`.trim() ||
                                    "N/A"}
                                </TableCell>

                                {/* Actions */}
                                <TableCell>
                                  <IconButton
                                    onClick={() => handleEditTeam(item.id)}
                                  >
                                    <EditIcon />
                                  </IconButton>
                                  <IconButton
                                    onClick={() =>
                                      handleDeleteClick(item.id, item.title)
                                    }
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                  <IconButton
                                    onClick={() =>
                                      handleShowGallery(item.id, item.title)
                                    }
                                  >
                                    <CollectionsIcon />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    </Table>
                  )}
                </Droppable>
              </DragDropContext>
            </TableContainer>
            <Box mt={2} display="flex" justifyContent="center">
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
                size="large"
              />
            </Box>
          </>
        )}

        <Dialog
          open={deleteDialogOpen}
          onClose={() => setDeleteDialogOpen(false)}
        >
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete{" "}
              <span style={{ fontWeight: "bold" }}> {deleteTitle}</span>? This
              action cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
            <Button color="error" onClick={confirmDelete}>
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <GalleryUpload
          galleryDialogOpen={galleryDialogOpen}
          setGalleryDialogOpen={setGalleryDialogOpen}
          deleteTitle={deleteTitle}
          fk_sectionDataId={galleryId}
          companyId={companyId}
        />

        {isAddingTeam && (
          <Box>
            <Box display="flex" alignItems="center" gap={1} mb={2}>
              <IconButton onClick={() => setIsAddingTeam(false)}>
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="h6">Add </Typography>
            </Box>
            {languagesList?.length > 1 && (
              <Tabs
                value={currentLanguage}
                indicatorColor="primary"
                textColor="primary"
                onChange={(e, newValue) => setCurrentLanguage(newValue)}
              >
                {languagesList?.map((lang) => (
                  <Tab key={lang.code} value={lang.code} label={lang.name} />
                ))}
              </Tabs>
            )}

            <TextField
              sx={{ mt: 2 }}
              label="First Name"
              value={newTeam["ar"]?.firstName || ""}
              onChange={(e) =>
                handleInputChange(currentLanguage, "firstName", e.target.value)
              }
              fullWidth
            />
            <TextField
              sx={{ mt: 2 }}
              label="Last Name"
              value={newTeam[currentLanguage]?.lastName || ""}
              onChange={(e) =>
                handleInputChange(currentLanguage, "lastName", e.target.value)
              }
              fullWidth
            />
            <TextField
              sx={{ mt: 2 }}
              label="Email"
              value={newTeam[currentLanguage]?.email || ""}
              onChange={(e) =>
                handleInputChange(currentLanguage, "email", e.target.value)
              }
              fullWidth
            />
            <ReactQuill
              key={`brief-${currentLanguage}`}
              style={{
                marginTop: "15px",
                height: !isMobile ? "100px" : "auto",
              }}
              value={newTeam[currentLanguage]?.brief || ""}
              onChange={(value) =>
                handleInputChange(currentLanguage, "brief", value)
              }
              theme="snow"
              placeholder="Brief..."
              modules={{
                toolbar: [
                  [{ header: "1" }, { header: "2" }, { font: [] }],
                  [{ list: "ordered" }, { list: "bullet" }],
                  ["bold", "italic", "underline"],
                  [{ align: [] }],
                  ["link"],
                  [{ color: [] }, { background: [] }],
                  ["clean"],
                ],
              }}
            />
            <ReactQuill
              key={`description-${currentLanguage}`}
              style={{
                marginTop: "70px",
                height: !isMobile ? "100px" : "auto",
              }}
              value={newTeam[currentLanguage]?.description || ""}
              onChange={(value) =>
                handleInputChange(currentLanguage, "description", value)
              }
              theme="snow"
              placeholder="Description..."
              modules={{
                toolbar: [
                  [{ header: "1" }, { header: "2" }, { font: [] }],
                  [{ list: "ordered" }, { list: "bullet" }],
                  ["bold", "italic", "underline"],
                  [{ align: [] }],
                  ["link"],
                  [{ color: [] }, { background: [] }],
                  ["clean"],
                ],
              }}
            />
            <TextField
              sx={{ mt: 7 }}
              label="Profession"
              value={newTeam[currentLanguage]?.profession || ""}
              onChange={(e) =>
                handleInputChange(currentLanguage, "profession", e.target.value)
              }
              fullWidth
            />
            <TextField
              label="YouTube URL"
              fullWidth
              variant="outlined"
              sx={{ mt: 2 }}
              value={newTeam[currentLanguage]?.yt_url || ""}
              onChange={(e) =>
                handleInputChange(currentLanguage, "yt_url", e.target.value)
              }
            />
            <TextField
              label="Linkedin URL"
              fullWidth
              variant="outlined"
              sx={{ mt: 2 }}
              value={newTeam[currentLanguage]?.linkedin_url || ""}
              onChange={(e) =>
                handleInputChange(
                  currentLanguage,
                  "linkedin_url",
                  e.target.value
                )
              }
            />
            <TextField
              label="Facebook URL"
              fullWidth
              variant="outlined"
              sx={{ mt: 2 }}
              value={newTeam[currentLanguage]?.facebook_url || ""}
              onChange={(e) =>
                handleInputChange(
                  currentLanguage,
                  "facebook_url",
                  e.target.value
                )
              }
            />
            {config?.checkBoxLabel && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={newTeam[currentLanguage]?.custom_checkbox || false}
                    onChange={(e) =>
                      handleInputChange(
                        currentLanguage,
                        "custom_checkbox",
                        e.target.checked
                      )
                    }
                  />
                }
                label={config?.checkBoxLabel}
                sx={{ mt: 2 }}
              />
            )}
            <Attachments
              onAttachmentsChange={handleAttachmentsChange}
              media={media}
              currentLanguage={currentLanguage}
              onDeleteMainImage={handleDeleteMainImage}
              onDeleteAttachment={handleDeleteAttachment}
            />
            <Box sx={{ mt: 8, display: "flex", justifyContent: "flex-end" }}>
              <Button
                onClick={() => setIsAddingTeam(false)}
                sx={{ marginRight: 2 }}
                color="error"
                variant="contained"
              >
                Cancel
              </Button>
              <Button
                onClick={handleSaveLanguage}
                color="primary"
                variant="contained"
              >
                Save / Skip
              </Button>
            </Box>
            <Dialog
              open={confirmationDialogOpen}
              onClose={() => setConfirmationDialogOpen(false)}
            >
              <DialogTitle>Proceed to Next Language?</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Do you want to proceed to the next language or finalize?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleExitAndSave} color="primary">
                  Exit And Save
                </Button>
                <Button onClick={handleProceedToNextLanguage} color="primary">
                  Next Language
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        )}
      </Paper>
    </StyledContainer>
  );
}
